module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-action-buttons"
  }, [(_vm.$is('action')) ? _c('ul', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "dropdown menu",
    attrs: {
      "data-dropdown-menu": ""
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")]), _c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.actions), function(action) {
    return _c('li', [_c('a', {
      on: {
        "click": action.callback
      }
    }, [_vm._v(_vm._s(action.name))])])
  }), 0)])]) : _c('div', {
    staticClass: "dropdown-buttons"
  }, _vm._l((_vm.actions), function(action) {
    return _c('button', {
      staticClass: "button",
      class: action.severity,
      attrs: {
        "type": "button"
      },
      on: {
        "click": action.callback
      }
    }, [_vm._v(_vm._s(action.name))])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f939b682!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/ActionButtons.vue
// module id = 2580
// module chunks = 1